import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CouponDispatch from '../../components/BatchProposal/CouponDispatch'
import {
  fetchListings,
  fetchProductBundles,
  createSupplierCoupons,
  fetchAbandonedCarts,
  setI13nData
} from '../../actions'
import {
  setToast
} from '../../actions/common'

CouponDispatch.fetchData = async ({
  store,
  req,
  res,
  match
}) => {
  try {
    const tasks = []
    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    supplier: state.supplier,
    page: state.page,
    env: state.page.env
  }
}

const mapDispatchToProps = (dispatch) => {
  const actions = {
    fetchListings,
    fetchProductBundles,
    createSupplierCoupons,
    fetchAbandonedCarts,
    setI13nData,
    setToast
  }
  return {
    actions: {
      ...bindActionCreators(actions, dispatch)
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CouponDispatch)
